export default "__VITE_ASSET__C0071dTu__"